/** @jsxImportSource @emotion/react */
import React from 'react';
import { jsx, css } from '@emotion/react';
import { useIntl } from 'react-intl-next';
import { defineMessages } from 'components/i18n';

type Props = {
  intervalUnit: 'day' | 'week' | 'month';
  intervalNumber: number;
}

export const intervalUnits: {[key: string]: any} = defineMessages({
  day: {
    id: 'common.day',
    defaultMessage: 'day',
  },
  days: {
    id: 'common.days',
    defaultMessage: 'days',
  },
  week: {
    id: 'common.week',
    defaultMessage: 'week',
  },
  weeks: {
    id: 'common.weeks',
    defaultMessage: 'weeks',
  },
  month: {
    id: 'common.month',
    defaultMessage: 'month',
  },
  months: {
    id: 'common.months',
    defaultMessage: 'months',
  },
  year: {
    id: 'common.year',
    defaultMessage: 'year',
  },
  years: {
    id: 'common.years',
    defaultMessage: 'years',
  }
});

const RecurringSaleSchedule: React.FC<Props> = ({intervalNumber, intervalUnit}) => {
    const intl = useIntl();

  const every =  intl.formatMessage({id: 'common.every', defaultMessage: 'Every'});
  const intervalUnitText =  intl.formatMessage(intervalUnits[intervalNumber === 1 ? intervalUnit : `${intervalUnit}s`]).toLowerCase();

  if(intervalNumber === 1) {
    return <span>{`${every} ${intervalUnitText}`}</span>
  }
  return <span>{`${every} ${intervalNumber} ${intervalUnitText}`}</span>;

};

export default RecurringSaleSchedule;
